import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CharactersRemainingComponent } from './characters-remaining';
import { MaximumCharactersComponent } from './maximum-characters';
import { PendingButtonComponent } from './pending-button';
import { RequiredFieldComponent } from './required-field';

@NgModule({
  imports: [CommonModule],
  declarations: [
    RequiredFieldComponent,
    MaximumCharactersComponent,
    CharactersRemainingComponent,
    PendingButtonComponent,
  ],
  exports: [
    RequiredFieldComponent,
    MaximumCharactersComponent,
    CharactersRemainingComponent,
    PendingButtonComponent,
  ],
})
export class FormHelperComponentsModule {}
